window.$ = window.jQuery = require('jquery');
require('jquery-mask-plugin');
require('bootstrap');
require('./validation');
require('jquery-validation');

window.onload = function () {
    if (window.location.href.includes('pagamento')) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'begin_checkout',
            ecommerce: {
                currency: 'BRL',
                value: document.getElementById("initialPrice").value,
                coupon: $("#coupon").val(),
                actionField: { step: 1, option: 'initiate_checkout' },
                items: [
                    {
                        item_id: document.getElementById("sku").value,
                        item_name: document.getElementById("productName").value,
                        price: document.getElementById("initialPrice").value,
                        item_brand: 'Goods Br',
                        item_category: 'BOOK BOX',
                        quantity: 1,
                    },
                ],
            },
        });
    }
    let name = document.getElementById('name');
    let email = document.getElementById('email');
    let phone = document.getElementById('phone');
    let happen = 0;
    const RDInputs = [name, email, phone];
    RDInputs.forEach(input => {
        input.addEventListener('focusout', () => {
            if (name.value && email.value && phone.value && happen == 0) {
                const options = {
                    method: 'POST',
                    headers: {
                        accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer'
                    },
                    body: JSON.stringify({
                        event_type: 'CONVERSION',
                        event_family: 'CDP',
                        payload: {
                            conversion_identifier: 'winebook_checkout',
                            email: document.getElementById("email").value,
                            name: document.getElementById("name").value,
                            mobile_phone: document.getElementById("phone").value
                        }
                    })
                };
                fetch('https://api.rd.services/platform/conversions?api_key=tcPmuWYerdLqpcuzLzOigrvvSajcWRkzcbCB', options)
                    .then(response => response.json())
                    .then(response => console.log(response))
                    .catch(err => console.error(err));
                happen = 1
            }
        });
    });
    let zipCode = document.getElementById('zipcode');
    let address = document.getElementById('address');
    let district = document.getElementById('district');
    let number = document.getElementById('number');
    let city = document.getElementById('city');
    let state = document.getElementById('state');

    const shippingInputs = [zipCode, city, address, district, number, state];

    shippingInputs.forEach(input => {
        input.addEventListener('focusout', () => {
            if (zipCode.value && address.value && district.value && number.value && city.value && state.value) {

                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: 'add_shipping_info',
                    ecommerce: {
                        currency: 'BRL',
                        value: document.getElementById("finalPrice").value,
                        coupon: $("#coupon").val(),
                        shipping_tier: 'JADLOG',
                        shipping: document.getElementById("freightPrice").value,
                        actionField: { step: 2, option: 'add_shipping_info' },
                        items: [
                            {
                                item_id: document.getElementById("sku").value,
                                item_name: document.getElementById("productName").value,
                                price: document.getElementById("initialPrice").value,
                                item_brand: 'Goods Br',
                                item_category: 'BOOK BOX',
                                quantity: document.getElementById("quantity").value,
                            },
                        ],
                    },
                });
            }
        });
    });

    let cCardNumber = document.getElementById('creditCardNumber');
    let cExpirationDate = document.getElementById('creditExpirationDate');
    let cName = document.getElementById('creditName');
    let cSecurityCode = document.getElementById('creditSecurityCode');

    let dCardNumber = document.getElementById('debitCardNumber');
    let dExpirationDate = document.getElementById('debitExpirationDate');
    let dName = document.getElementById('debitName');
    let dSecurityCode = document.getElementById('debitSecurityCode');

    const creditInputs = [cCardNumber, cExpirationDate, cName, cSecurityCode];
    const debitInputs = [dCardNumber, dExpirationDate, dName, dSecurityCode];

    creditInputs.forEach(input => {
        input.addEventListener('focusout', () => {
            if (cCardNumber.value && cExpirationDate.value && cName.value && cSecurityCode.value) {

                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: 'add_payment_info',
                    ecommerce: {
                        currency: 'BRL',
                        value: document.getElementById("finalPrice").value,
                        coupon: $("#coupon").val(),
                        payment_type: "Credit",
                        shipping_tier: 'JADLOG',
                        shipping: document.getElementById("freightPrice").value,
                        actionField: { step: 3, option: 'add_payment_info' },
                        items: [
                            {
                                item_id: document.getElementById("sku").value,
                                item_name: document.getElementById("productName").value,
                                price: document.getElementById("initialPrice").value,
                                item_brand: 'Goods Br',
                                item_category: 'BOOK BOX',
                                quantity: document.getElementById("quantity").value,
                            },
                        ],
                    },
                });

            }
        });
    });

    debitInputs.forEach(input => {
        input.addEventListener('focusout', () => {
            if (dCardNumber.value && dExpirationDate.value && dName.value && dSecurityCode.value) {

                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: 'add_payment_info',
                    ecommerce: {
                        currency: 'BRL',
                        value: document.getElementById("finalPrice").value,
                        coupon: $("#coupon").val(),
                        payment_type: "Debit",
                        shipping_tier: 'JADLOG',
                        shipping: document.getElementById("freightPrice").value,
                        actionField: { step: 3, option: 'add_payment_info' },
                        items: [
                            {
                                item_id: document.getElementById("sku").value,
                                item_name: document.getElementById("productName").value,
                                price: document.getElementById("initialPrice").value,
                                item_brand: 'Goods Br',
                                item_category: 'BOOK BOX',
                                quantity: document.getElementById("quantity").value,
                            },
                        ],
                    },
                });

            }
        });
    });
};

$(document).ready(function () {
    $('#debitCard').hide();
    $('#PIX').hide();
    $('#creditCard').show();
    $('#debitCard').hide();
    $('#creditCardNumber').attr({ required: 'true', minlength: '19' });
    $('#creditExpirationDate').attr({ required: 'true', minlength: '5' });
    $('#creditName').attr({ required: 'true' });
    $('#creditSecurityCode').attr({ required: 'true', minlength: '3' });
    $('#installments').attr({ required: 'true' });
    $('#debitCardNumber').removeAttr('required');
    $('#debitExpirationDate').removeAttr('required');
    $('#debitName').removeAttr('required');
    $('#debitSecurityCode').removeAttr('required');

    if ($('#chargeCheckBox').is(':checked')) {
        $('.charge-address').removeAttr('required');
        $('#chargeAddressForm').hide();
    } else {
        $('.charge-address').attr({ required: 'true', minlength: '1' });
        $('#chargeAddressForm').show();
    }
    $('#chargeCheckBox').on('click', function () {
        if ($('#chargeCheckBox').is(':checked')) {
            $('.charge-address').removeAttr('required');
            $('#chargeAddressForm').hide();
        } else {
            $('.charge-address').attr({ required: 'true', minlength: '1' });
            $('#chargeAddressForm').show();
        }
    });
    $('.form-check-input').on('click', function () {
        if ($('#creditButton').is(':checked')) {
            $('#creditCard').show();
            $('#debitCard').hide();
            $('#creditCardNumber').attr({ required: 'true', minlength: '19' });
            $('#creditExpirationDate').attr({ required: 'true', minlength: '5' });
            $('#creditName').attr({ required: 'true' });
            $('#creditSecurityCode').attr({ required: 'true', minlength: '3' });
            $('#installments').attr({ required: 'true' });
            $('#debitCardNumber').removeAttr('required');
            $('#debitExpirationDate').removeAttr('required');
            $('#debitName').removeAttr('required');
            $('#debitSecurityCode').removeAttr('required');
        } else if ($('#debitButton').is(':checked')) {
            $('#creditCard').hide();
            $('#debitCard').show();
            $('#PIX').hide();
            $('#creditCardNumber').removeAttr('required');
            $('#creditExpirationDate').removeAttr('required');
            $('#creditName').removeAttr('required');
            $('#creditSecurityCode').removeAttr('required');
            $('#installments').removeAttr('required');
            $('#debitCardNumber').attr({ required: 'true', minlength: '19' });
            $('#debitExpirationDate').attr({ required: 'true', minlength: '5' });
            $('#debitName').attr({ required: 'true' });
            $('#debitSecurityCode').attr({ required: 'true', minlength: '3' });
        } else if ($('#PIXButton').is(':checked')) {
            $('#creditCard').hide();
            $('#debitCard').hide();
            $('#PIX').show();
            $('#debitCardNumber').removeAttr('required');
            $('#debitExpirationDate').removeAttr('required');
            $('#debitName').removeAttr('required');
            $('#debitSecurityCode').removeAttr('required');
        }
    });

    ////////////////////////////////////

    $('#cpf').mask('000.000.000-00', { reverse: true });
    $('#zipcode').mask('00000-000');
    $('#chargeZipcode').mask('00000-000');
    $('#creditCardNumber').mask('0000 0000 0000 0000');
    $('#debitCardNumber').mask('0000 0000 0000 0000');
    $('#debitExpirationDate').mask('00/00');
    $('#creditExpirationDate').mask('00/00');
    $('#creditSecurityCode').mask('000');
    $('#debitSecurityCode').mask('000');
    $('#quantity').mask('099');

    var maskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
        options = {
            onKeyPress: function (val, e, field, options) {
                field.mask(maskBehavior.apply({}, arguments), options);
            }
        };

    $('#phone').mask(maskBehavior, options);

    ///////////////////////////
    var alredyReseted = false;
    function resetPrices() {

        $(document).ready(function () {
            $('#coupon-btn').html('Aplicar');
        })
        $('#subprice').text(($('#price').val() * $("#quantity").val()).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }));
        $('#subprice').val(($('#price').val() * $("#quantity").val()));
        console.log($('#freightPrice').val());
        if ($('#freightPrice').val() != '') {
            $('#total').text((parseFloat($('#subprice').val()) + parseFloat($('#freightPrice').val())).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }));
            $('#finalPrice').val((parseFloat($('#subprice').val()) + parseFloat($('#freightPrice').val())).toFixed(2));
            $('#installments').find('option').remove();
            for (var i = 1; i <= $('#product-installments').val(); i++) {
                $('#installments').append('<option value="' + i + '">' + i + 'x de ' + ($('#finalPrice').val() / i).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) + '</option>');
            }
        } else {
            $('#installments').find('option').remove();
            for (var i = 1; i <= $('#product-installments').val(); i++) {
                $('#installments').append('<option value="' + i + '">' + i + 'x de ' + ($('#subprice').val() / i).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) + '</option>');
            }
        }

    }

    function refresh() {
        if ($('#couponAplicated').val() == '') {
            var staticPrice = $('#initialPrice').val() * 1;
            if ($('#validCoupon').val() != '') {
                $.get("/cupom", { code: $("#validCoupon").val() }, function (data) {
                    if (data && data.percentage > 0) {
                        $('#price').text((staticPrice - (staticPrice / data.percentage)).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }));
                        $('#price').val(staticPrice - (staticPrice / data.percentage));
                        $('#oldPrice').text((staticPrice).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }));
                        $('#oldPrice').removeClass("d-none").addClass("text-decoration-line-through");
                        $('#coupon').removeClass("border-danger").addClass("border-success").attr("disabled", 'disabled');
                        $('#couponAplicated').val('true');
                        $('#coupon-btn').attr("disabled", 'disabled');
                        createFreight();
                        resetPrices();
                    } else {
                        $('#price').text((staticPrice).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }));
                        $('#price').val(staticPrice);
                        resetPrices();
                    }
                });
            } else {
                $('#price').text((staticPrice).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }));
                $('#price').val(staticPrice);
                resetPrices();
            }
        } else { resetPrices(); }
    }

    function changeQuantity() {
        if ($("#quantity").val() <= 0) {
            $("#quantity").val("1");
        } else if ($('#quantity').val() > $('#stock').val()) {
            $("#quantity").val($('#stock').val() - 1);
        };
        refresh();
    }

    function tryCoupon() {
        $(document).ready(function () {
            $('#coupon-btn').html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
        });
        $.get("/cupom", { code: $("#coupon").val() }, function (data) {
            if (data && data.freight > 0) {
                $('#freight').html('Grátis');
                $('#freightPrice').val(0);
                $('#freightMessage').text('Cupom aplicado');
                $('#freightCoupon').val(true);
            }
            if (data && data.percentage > 0) {
                $('#validCoupon').val($("#coupon").val());
            }
            if (data = '0') {
                $('#coupon').addClass("border-danger");
            }
            refresh();
        });

    }

    function createFreight() {
        cep = $("#zipcode").val().replace(/\D/g, '');
        var validacep = /^[0-9]{8}$/;
        if (cep.length > 7) {
            if (validacep.test(cep)) {
                if ($("#haveFreight").val() == 1 && $("#freightCoupon").val() === 'false') {
                    $(document).ready(function () {
                        $.get("/jadlog", { zipcode: cep, price: parseFloat($("#price").val()).toFixed(2), weight: $('#weight').val(), quantity: $('#quantity').val() }, function (data) {
                            $('#freightPrice').val(data['vltotal']);
                            $('#freight').text((data['vltotal']).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }));
                            $('#freight2').text((data['vltotal']).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }));
                            refresh();
                        });
                    });
                } else {
                    $('#total').text((parseFloat($('#subprice').val())).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }));
                    $('#finalPrice').val((parseFloat($('#subprice').val())).toFixed(2));
                }
                $.getJSON("https://viacep.com.br/ws/" + cep + "/json/?callback=?", function (dados) {
                    if (!("erro" in dados)) {
                        $("#rua").val(dados.logradouro);
                        $("#bairro").val(dados.bairro);
                        $("#city").val(dados.localidade);
                        $("#state").val(dados.uf);
                    }
                });
            } else {
                $('#total').text('R$ XX,XX');
                $('#freight').text('Digite o CEP');
                $('#freight2').text('Digite o CEP');
            }
            refresh();
        }
    }

    $("#zipcode").on('keyup', function () {
        createFreight();
    });

    $('#quantity').on('change', function () {
        changeQuantity();
    });

    $("#coupon-btn").on('click', function (e) {
        tryCoupon();
    });


    $urlParams = new URLSearchParams(window.location.search);
    $("#token").val($urlParams.get('token'));
    if ($urlParams.has('coupon')) {
        $("#coupon").val($urlParams.get('coupon'));
        $("#coupon-btn").trigger("click");
    };

    if ($("#zipcode").val() != '') { $("#zipcode").blur(); }


    $("#chargeZipcode").on('blur', function (e) {
        cep = $("#chargeZipcode").val().replace(/\D/g, '');
        var validacep = /^[0-9]{8}$/;
        if (validacep.test(cep)) {
            $.getJSON("https://viacep.com.br/ws/" + cep + "/json/?callback=?", function (dados) {
                if (!("erro" in dados)) {
                    $("#chargeCity").val(dados.localidade);
                    $("#chargeState").val(dados.uf);
                }
            });
        }
    });

    if ($('#error-message').length) {
        $("html, body").animate({ scrollTop: $(document).height() }, 1000);
    }

    $("#paymentForm").on('submit', function (event) {
        $('#paymentBtn').attr("disabled", 'disabled').html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
        event.preventDefault();
        setTimeout(function () {
            $('#paymentBtn').prop("disabled", false).html('FINALIZAR COMPRA');
            return;
        }, 2000);
    });
});